export default function useFilterField() {

    const handleFilter = ({ list, value, column }) => {

        const listFilter = []

        list.map((el) => {
            const obj = {
                ...el
            }
            delete obj.id

            const items = []
            Object.keys(el).map(key => {
                if (key == column) {
                    items.push(el[key])
                }
            })
            const compare = handleCompareColumn(items)
            if (compare.length > 0) {
                if (!!compare.find(item => item?.toUpperCase() == value?.toUpperCase())) {
                    listFilter.push(el)
                }
            }
        })
        return listFilter
    }

    const handleCompareColumn = (items) => {
        const compare = []
        if (Array.isArray(items)) {
            items?.map((item) => {
                if (!Array.isArray(item) && typeof item != "object") {
                    compare.push(String(item))
                } else if (Array.isArray(item)) {
                    compare.push(...handleCompare(item))
                } else if (typeof item != "object") {
                    Object.keys(item).map((dados, i) => {
                        if (Array.isArray(item[dados]) || typeof item[dados] == "object") {
                            compare.push(...handleCompare(item[dados]))
                        } else {
                            compare.push(String(item[dados]))
                        }
                    })
                }
            })
        }
        return compare
    }

    const handleCompare = (items) => {
        const compare = []
        if (Array.isArray(items)) {
            items?.map((item) => {
                if (!Array.isArray(item) && typeof item != "object") {
                    compare.push(String(item))
                } else if (Array.isArray(item)) {
                    compare.push(...handleCompare(item))
                } else if (typeof item != "object") {
                    Object.keys(item).map((dados, i) => {
                        if (Array.isArray(item[dados]) || typeof item[dados] == "object") {
                            compare.push(...handleCompare(item[dados]))
                        } else {
                            compare.push(String(item[dados]))
                        }
                    })
                }
            })
        }
        return compare
    }

    return {
        handleFilter
    }
}